import styled from 'styled-components';

export const CertName = styled.h6`
  font-size: 12px;
  color: hsl(0deg, 0%, 0%, 68%);
  text-transform: uppercase;
  padding: ${(props) => (props.clinicListing ? '0 0 6px' : '6px 0')};
  font-weight: 500;
  letter-spacing: 2px;
  @media (max-width: 720px) {
    display: ${(props) => (props.hideSection ? 'none' : 'inline')};
  }
`;
